<template lang="pug" src="./html/LincolnVirtualCarConfig-Body.pug"></template>

<script>
    import PortfolioItemBase from './PortfolioItemBase'

    export default {
      extends: PortfolioItemBase,
      mounted () {
        this.setupVideo('132008773', 'https://player.youku.com/embed/XMTgyMDcyODY4OA==')
      }
    }
</script>
